import React from 'react';

const milestones = [
  {
    year: '2025 – Present',
    title: 'Resmed → Nasdaq Verafin',
    description: 'Senior Software Engineer in Toronto, building anti-fraud and AML infrastructure.',
  },
  {
    year: '2024',
    title: 'Canada Revenue Agency',
    description: 'Software Engineer in Toronto, building RAG systems and event-driven pipelines.',
  },
  {
    year: '2023 – 2024',
    title: 'Dalhousie University',
    description: "Master's in Applied Computer Science, Halifax.",
  },
  {
    year: '2022',
    title: 'Moved to Canada',
    description: 'Relocated to Halifax to start a new chapter.',
  },
  {
    year: '2019 – 2022',
    title: 'MathWorks',
    description: 'Software Engineer in Bengaluru, working on Simulink.',
  },
  {
    year: '2015 – 2019',
    title: 'IIIT-Delhi',
    description: 'B.Tech in Computer Science, New Delhi.',
  },
];

function Journey() {
  return (
    <section id="journey" className="mb-16">
      <h2 className="text-sm font-semibold uppercase tracking-wide text-gray-500 mb-8">
        Journey
      </h2>
      <div className="relative pl-6 border-l border-gray-300 space-y-10">
        {milestones.map((m) => (
          <div key={m.year} className="relative">
            <span className="absolute -left-[27px] top-1.5 w-2.5 h-2.5 rounded-full bg-gray-900" />
            <p className="text-sm text-gray-500 mb-0.5">{m.year}</p>
            <h3 className="text-lg font-semibold">{m.title}</h3>
            <p className="text-gray-700">{m.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Journey;
